import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterStaticLinkDirectiveModule } from '@icilalune/utils';
import { TranslocoModule } from '@ngneat/transloco';
import { MediaSvgComponentModule } from '@nx-icilalune/icilalune/media';
import { SvgMedia } from '@nx-icilalune/drupal-types';

export interface ClientLink {
  title: string | undefined;
  path: string | undefined;
  logo: SvgMedia | undefined;
}

@Component({
  selector: 'i2l-ui-client-link',
  template: `
    <ng-container *ngIf="client">
      <a [routerStaticLink]="client.path">
        <ng-container *ngIf="client.logo as logo">
          <i2l-media-svg [svgMedia]="logo"></i2l-media-svg>
        </ng-container>
      </a>
    </ng-container>
  `,
  styleUrls: ['./client-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientLinkComponent {
  @Input()
  client: ClientLink | undefined;
}

@NgModule({
  imports: [
    CommonModule,
    RouterStaticLinkDirectiveModule,
    TranslocoModule,
    MediaSvgComponentModule,
  ],
  declarations: [ClientLinkComponent],
  exports: [ClientLinkComponent],
})
export class ClientLinkComponentModule {}
